<template lang='pug' src='./accessibility.pug'></template>

<script>
import Loader from 'components/loader/loader'
import Modal from 'components/modal/modal'

export default {
  name: 'Accessibility',
  computed: {
    props () {
      return this.$store.state.pages['new-patients']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  created () {
    this.$store.dispatch('VIEW_NAV', true)
  },
  components: {
    Loader,
    Modal
  },
  data () {
    return {
      companyName: 'H2 Pediatric Dentistry Orthodontics', // Fill this in
      domain: "<a href='https://pediatricdentistorangeca.com'>pediatricdentistorangeca.com</a>", // Fill this in
      email: "<a href='mailto:info@h2pedo.com'>info@h2pedo.com</a>", // Fill this in
      phone: "<a href='tel:+17145329700'>714-532-9700</a>", // Fill this in
      formattedEmail: ''
    }
  },
  mounted () {
    this.formatEmail()
  },
  methods: {
    formatEmail () {
      this.formattedEmail = '<a aria-label="email ' + this.email + '" href="mailto:' + this.email + '">' + this.email + '</a>'
    }
  }
}
</script>



// WEBPACK FOOTER //
// accessibility.vue?09e0ebd0